import { useState } from 'react';

import { ActionIcon, Button } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';

import { useGlobalShortcut } from '@/hooks/useGlobalShortcut';
import { useChartStore } from '@/store/chartStore';

import { RangeFilterModal } from './RangeFilterModal';

/**
 * Filter button that opens the range filter modal
 * Also registers Cmd+K / Ctrl+K global shortcut
 */
export function RangeFilterButton() {
  const [modalOpened, setModalOpened] = useState(false);
  const visibleHands = useChartStore((state) => state.visibleHands);

  const isFilterActive = visibleHands !== null;

  // Register global shortcut (Cmd+K or Ctrl+K)
  useGlobalShortcut('k', { meta: true }, () => setModalOpened(true));

  const handleClick = () => setModalOpened(true);

  return (
    <>
      <ActionIcon
        variant="subtle"
        color={isFilterActive ? 'blue' : 'gray'}
        size="lg"
        onClick={handleClick}
        aria-label="Filter hands"
        hiddenFrom="sm"
      >
        <IconFilter size={18} />
      </ActionIcon>
      <Button
        variant="subtle"
        color={isFilterActive ? 'blue' : 'gray'}
        size="compact-sm"
        onClick={handleClick}
        leftSection={<IconFilter size={16} />}
        visibleFrom="sm"
      >
        Filter
      </Button>

      <RangeFilterModal opened={modalOpened} onClose={() => setModalOpened(false)} />
    </>
  );
}
